import React from "react";

import { Logo } from "./logo";

const OnboardingMobileWarning = () => {
  return (
    <div style={{ height: "100vh" }} className="flex column full-width">
      <Logo className="absolute m10" />
      <div className="self-center mx-auto">
        <div className="flex flex-column items-center">
          <div className="px10" style={{ transform: "translateY(-50px)" }}>
            <h2 className="text-black-tint-20 h2 mb4">Device not supported</h2>
            <div className="body-s text-black-tint-10">
              <p>
                We’re sorry, but setting up your account is currently not possible on a mobile
                device.
              </p>
              <p>
                Please try again from a computer that meets our{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://help.minervaproject.com/en/articles/4292732-computer-requirements"
                >
                  minimum requirements.
                </a>{" "}
              </p>
              <p>
                If you have any questions, you can check out our{" "}
                <a target="_blank" rel="noreferrer" href="http://help.minervaproject.com">
                  help documentation
                </a>{" "}
                or{" "}
                <a
                  target="_blank"
                  hreft="https://help.minervaproject.com/en/articles/4296187-contacting-live-chat-support"
                >
                  contact support.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { OnboardingMobileWarning };
